module.exports = __webpack_public_path__ + "static/img/3.ab84cda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/3.png
// module id = OxEy
// module chunks = 57